import {
  addItemToCollection,
  updateItemInCollection,
  getItemFromCollection,
  getItemsFromCollection,
  deleteItemFromCollection,
} from "directus/src/operations"; 


export async function saveSearchHistory({ prompt, results, relevancyMessage, relevancyCategory }) {
  try {
    const truncatedTitle = prompt.slice(0, 255);

    const payload = {
      project_query_title: truncatedTitle,
      project_search_history_chat: {
        create: [
          {
            project_chat: {
              create: [
                {
                  project_query: prompt,
                  project_response: {
                    project_recommendations: results,
                    relevancy_message: relevancyMessage,
                    relevancy_category: relevancyCategory,
                  },
                },
              ],
            },
          },
        ],
      },
    };

    const response = await addItemToCollection("project_search_histories", payload);
    console.log("response",response);
    
    return response;
  } catch (error) {
    console.error("Error saving search history:", JSON.stringify(error, null, 2));
    throw error;
  }
}

export async function appendChatToExistingHistory(historyId, { prompt, results, relevancyMessage, relevancyCategory }) {
  try {
    const payload = {
      project_search_history_chat: {
        create: [
          {
            project_chat: {
              create: [
                {
                  project_query: prompt,
                  project_response: {
                    project_recommendations: results,
                    relevancy_message: relevancyMessage,
                    relevancy_category: relevancyCategory,
                  },
                },
              ],
            },
          },
        ],
      },
    };

    const response = await updateItemInCollection("project_search_histories", historyId, payload);
    return response;
  } catch (error) {
    console.error("Error appending chat to history:", error);
    throw error;
  }
}

export async function getSearchHistory() {
  try {
    const query = {
      fields: [
        "id",
        "project_query_title",
        "date_created",
      ],
      sort: ["-date_created"],
    };

    const response = await getItemsFromCollection("project_search_histories", query);
    return Array.isArray(response) ? response : [];
  } catch (error) {
    console.error("Error fetching search history:", error);
    return []; // Return empty array on error
  }
}

export async function getSearchById(id) {
  try {
    const query = {
      fields: [
        "project_query_title",
        "project_search_history_chat.project_chat.project_query",
        "project_search_history_chat.project_chat.project_response",
      ],
      deep: {
        project_search_history_chat: {
          _sort: "date_created"
        }
      }
    };

    const response = await getItemFromCollection("project_search_histories", id, query);
    if (response && response.project_search_history_chat) {
      const chatHistory = response.project_search_history_chat.map(item => item.project_chat);
      return { ...response, project_search_history_chat: chatHistory };
    }
    return response;
  } catch (error) {
    console.error("Error fetching history by ID:", error);
    throw error;
  }
}

export async function deleteSearchHistory(id) {
  try {
    const response = await deleteItemFromCollection("project_search_histories", id);
    return response;
  } catch (error) {
    console.error("Error deleting search history:", error);
    throw error;
  }
}
